import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import {
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight,
    MdCreate,
    MdBlock,
    MdOutlineFileDownload,
    MdKeyboardDoubleArrowRight,
    MdOutlineCircle,
    MdOutline10K,
    MdAdd,
} from "react-icons/md";
import { FaBell, FaRocket } from "react-icons/fa6";
import { useNavigate, Link, useLocation } from "react-router-dom";
import _constantUtil, { ONE } from "../../../utils/Constant";
import config from "../../../config/config";
import Loader from "../../partial/Loader";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip } from "react-tooltip";
import logo from "../../../assets/images/logo.png";
import { IoIosLock, IoIosUnlock  } from "react-icons/io";
import { TbCircleLetterBFilled } from "react-icons/tb";


function UpcomingMatch() { 
    const navigate = useNavigate();
  
    const [showMatch, setShowMatch] = useState(_constantUtil.BOOLEAN_FALSE); 
    const [isiD, setIsiD] = useState("");
    const [currentPage, setCurrentPage] = useState(_constantUtil.ZERO);
    const rowsPerPage= 20;
 
    const confirmationRef = useRef(_constantUtil.NULL); 
    useEffect(() => { 
        const handleClickOutside = (event) => {
            if (
                confirmationRef.current &&
                !confirmationRef.current.contains(event.target)
            ) { 
                setShowMatch(_constantUtil.BOOLEAN_FALSE);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [currentPage, rowsPerPage, showMatch]); 

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    }; 
    return (
        <> 
            {showMatch && (
                <div>
                    <div className="confirmation-overlay"></div>
                    <div ref={confirmationRef} className="confirmation-dialog">
                        <p>Are you sure to update match status ?</p>
                        <div className="d-flex justify-content-end ">
                            <button
                                onClick={() => {
                                    setShowMatch(_constantUtil.BOOLEAN_FALSE); 
                                }}
                                className="border-0 rounded px-3 bg-danger text-white p-2"
                            >
                                Cancel
                            </button>
                            <button 
                                className="border-0 rounded px-3 bg-success text-white p-2" 
                            >
                               Confirm 
                            </button>
                        </div>
                    </div>
                </div>
            )} 
            <div className="px-4 ">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-between ">
                            <h4 className="header-title pb-3 mt-4 "> 
                                Upcoming Match
                            </h4> 
                        </div>
                        <div className="col-12  ">
                            <div className="card">
                                <div className="card-body">
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <input
                                        type="text"
                                        className="form-control search-width me-2  "
                                        id="search"
                                        name="search"
                                        placeholder="Search..."
                                        style={{ width: "15%" }} 
                                        autoComplete="off"
                                    />
                                    <div className='d-flex '>
                                        <div className=''>
                                            <button
                                                type='button'
                                                className='btn jumbo-bg-dull-sky text-white' 
                                                onClick={()=>navigate('/match/add-upcoming-match')}
                                            > 
                                            <MdAdd className='fs-5 me-1 mb-1 ' />
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                    <div className="table-responsive">
                                        <table
                                            id="scroll-horizontal-datatable"
                                            className="table w-100 nowrap"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Match Title</th>
                                                    <th>Tournament Name</th>
                                                    <th>Country</th>
                                                    <th className="text-nowrap">Date & Time</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>IND vs PAK <br /> (India vs Pakistan)</td>
                                                    <td>Premier League</td>
                                                    <td>Afghanistan</td>
                                                    <td>2024-10-02 <br />13:30:00</td>
                                                    <td>
                                                        <span className="badge badge-success-lighten">
                                                            ACTIVE
                                                        </span>
                                                    </td>
                                                    <td>
                                                    <TbCircleLetterBFilled
                                                        data-tooltip-id="view-bets" data-tooltip-content="View Bets" 
                                                        className="jumbo-icon pointer text-info user-status fs-4 me-2" style={{ cursor: "pointer" }} 
                                                        onClick={() => navigate(`/match/upcoming-bets`)}
                                                    />
                                                    <Tooltip id="view-bets" place="bottom" effect="solid" /> 

                                                    <MdCreate
                                                        data-tooltip-id="updatematch" data-tooltip-content="Update Match"
                                                        className="jumbo-icon fs-5 me-2" style={{ cursor: "pointer", color: "gray", }}
                                                        onClick={() => navigate( `/match/update-match`, { state : { Mcount : 1}} )}
                                                    />
                                                    <Tooltip border={ false } id="updatematch" place="bottom" effect="solid" />

                                                    <MdOutlineCircle
                                                        data-tooltip-id="active-match" data-tooltip-content="Active Match" 
                                                        className="jumbo-icon pointer text-success user-status fs-5 me-2" style={{ cursor: "pointer" }} 
                                                        onClick={()=>setShowMatch(_constantUtil.BOOLEAN_TRUE)}
                                                    />
                                                    <Tooltip id="active-match" place="bottom" effect="solid" />
                                                    </td>
                                                </tr> 
                                            </tbody>
                                        </table>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={<MdKeyboardArrowLeft className="fs-4" /> }
                                        nextLabel={<MdKeyboardArrowRight className="fs-4" /> }
                                        className="pagination"
                                        breakLabel={"..."}
                                        breakClassName={"break-me"} 
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageChange}
                                        forcePage={currentPage} 
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination" }
                                        activeClassName={ "pagination-active-page"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpcomingMatch;
